module.exports = __webpack_public_path__ + "media/phone-ringtone.62916f2c.wav";